import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { styled } from 'styled-components';
import { IMenuItens } from '../Header';
import { HomeOutlined } from '@mui/icons-material';
import NavigateNextRoundedIcon from '@mui/icons-material/NavigateNextRounded';
import { findBreadcrumb } from './findBreadcrumb';
import { useTranslation } from '../../commons/useTranslasion';
import { esES, ptBR } from '@mui/material/locale';

interface BreadcrumbProps {
  conteudo?: {
    titulo: string;
    link: string;
  };
}

export const normalizeString = (texto: string) => {
  if (texto == "") return texto;

  // Normaliza a string removendo acentos
  const normalizedString = texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

  // Remove caracteres não alfanuméricos e coloca em minúsculas
  let result = normalizedString.replace(/[^a-zA-Z0-9]/g, "");

  // Retorna com a primeira letra maiúscula
  return result.charAt(0).toLowerCase() + result.slice(1);
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ conteudo }) => {
  const { translate, language } = useTranslation();
  const lang = language ?? "pt-br";
  let locale = ptBR;
  switch (lang.slice(0, 2)) {
    case "es":
      locale = esES
      break;
  }

  const location = useLocation();
  const currentPath = location.pathname;
  const [pageStructure, setPageStructure] = useState<IMenuItens[]>([]);

  useEffect(() => {
    const structure = JSON.parse(localStorage.getItem('menusDinamicos') ?? '[]') as IMenuItens[];
    structure.filter((area: any) => area.nome === 'Minha Transição')
    .forEach((item: any) => {
      item.nome = translate(normalizeString(item.nome));
      item.filhos?.forEach((filho: any) => {
        filho.nome = translate(normalizeString(filho.nome));
      });
    });

    setPageStructure(structure);
  }, [translate]);

  // Se temos um conteúdo e a URL contém "/conteudos/", queremos buscar o breadcrumb
  // até a seção pai, não incluindo o conteúdo ainda
  const pathToFind = conteudo && currentPath.includes('/conteudos/') 
    ? currentPath.split('/conteudos/')[0] 
    : currentPath;
  
  let breadcrumb = findBreadcrumb(pathToFind, pageStructure);

  // Se temos um conteúdo, adicionamos ao final do breadcrumb
  if (breadcrumb && conteudo) {
    breadcrumb = [...breadcrumb, { nome: conteudo.titulo, link: conteudo.link }];
  }

  return (
    <NavBreadcrumb className="breadcrumb">
      <HomeOutlined style={{ marginRight: '8px', height: '16px', width: '16px' }} />
      <NavigateNextRoundedIcon style={{ height: '16px', width: '16px', marginRight: '8px' }} />
      {breadcrumb &&
        breadcrumb.map((item, index) => (
          <span key={item.link} style={{ display: 'flex', alignItems: 'center' }}>
            {index > 0 && (
              <NavigateNextRoundedIcon
                style={{ height: '16px', width: '16px', marginRight: '8px' }}
              />
            )}
            <LinkBreadcrumb href={item.link}>{item.nome}</LinkBreadcrumb>
          </span>
        ))}
    </NavBreadcrumb>
  );
};

const NavBreadcrumb = styled.nav`
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: var(--gray-medium);
  display: flex;
  align-items: center;
`;

const LinkBreadcrumb = styled.a`
  color: var(--gray-medium);
  margin-right: 8px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export default Breadcrumb;
